<template>
  <div class="post">
    <el-button type="primary" plain icon="el-icon-plus" @click="handleAdd" size="small">新建</el-button>
    <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="ids.length == 0" @click="handleDel">删除</el-button>
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="ofrresourceName" label="发起审批岗位" >
        <!-- <template slot-scope="scope">
          <a @click="handleDetail(scope.row)" class="link">{{scope.row.name}}</a>
        </template> -->
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="70">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click.native.stop="handleDel(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialog-drag
      title="新增审批岗位"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="审批岗位" prop="ofrresourceIds">
          <el-select v-model="ruleForm.ofrresourceIds" placeholder="请选择审批岗位" style="width:100%" filterable multiple>
            <el-option v-for="(item, index) in postList" :key="index" :label="item.resourceName" :value="item.ofrResourceId"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import qs from 'qs'
import DictTag from '@/components/DictTag.vue'
import {mapState} from 'vuex'
  export default {
    computed: {
      ...mapState({
        dropDown: (state) => state.dropDown.dropDown
      })
    },
    components: {
      DictTag,
    },
    props: {
      cfappId: [String, Number],
    },
    data() {
      return {
        tableData: [],
        loading: false,
        dialogFormVisible: false,
        ruleForm: {
          ofrresourceIds: null,
          cfappId: null,
        },
        rules: {
          ofrresourceIds: [{ required: true, message: "请选择审批岗位", trigger: "submit" }]
        },
        isLoading: false,
        postList: [],
        ids: []
      }
    },
    created () {
      this.ruleForm.cfappId = this.cfappId
      this.getData();
      this.getList()
    },
    methods: {
      getData() {
        this.$http.get(url.getPostList).then(res => {
          if(res.data.code == 200) {
            this.postList = res.data.data
          }
        })
      },
      getList() {
        this.$http.get(url.getCfAppResourceList, {params: {cfappId: this.cfappId}}).then(res => {
          if(res.data.code == 200) {
            this.tableData = res.data.data
          }
        })
      },
      // 提交表单
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            this.ruleForm.ofrresourceIds = this.ruleForm.ofrresourceIds.toString()
            // 新增审批步骤
            this.$http.post(url.addCfAppResource, qs.stringify(this.ruleForm)).then(res => {
              // console.log(res);
              this.isLoading = false
              if(res.data.code === 200) {
                this.$message.success(res.data.msg);
                this.dialogFormVisible = false;
                this.getList()
              }
            })
          } else {
            return false;
          }
        });
      },
      handleAdd() {
        this.dialogFormVisible = true
        this.$nextTick(() => {
        // 清除表单校验效果
          this.$refs.ruleForm.clearValidate();
        })
        // 初始化表单内容
        this.ruleForm.ofrresourceIds = []
      },
      handleDel(row) {
        // console.log(row);
        let cfAppResourceIds = row.cfAppResourceId || this.ids.toString()
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(url.removeCfAppResource, qs.stringify({cfAppResourceIds})).then(res => {
            if(res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getList()
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleSelectionChange(rows) {
        this.ids = rows.map(item => item.cfAppResourceId)
      }
    },
    watch: {
      cfappId(newValue, oldValue) {
        console.log(newValue);
        // if(newValue) {
        //   this.ruleForm.cfappId = newValue
        //   this.getList()
        // }

      }
    },
  }
</script>

<style lang="scss" scoped>
.post {
  .el-table {
    margin-top: 16px;
  }
}
</style>
